export const DefaultQueryParams = {
  Mode: 'mode',
  Token: 'token',
  UserId: 'userid',
  GameId: 'gameid',
  ExitUrl: 'exiturl',
  Culture: 'culture',
  Currency: 'currency',
  PartnerId: 'partnerid',
  LicenseType: 'licensetype',
  TournamentId: 'tournamentid',
  PlayerId: 'playerexternalid',
  CurrencySymbol: 'currencysymbol',
  PlayerExternalId: 'playerexternalid',
};

export const LicenseTypes = {
  brazilianGlI: 1,
};
